import type {StyleRef} from '@wix/document-services-types'
import {migratePropertyBetweenStyleItems} from '../utils'

const propertiesToMigrate = [
    ['dropdown-container-background', 'container-background'],
    ['dropdown-container-border-top', 'container-border-top'],
    ['dropdown-container-border-right', 'container-border-right'],
    ['dropdown-container-border-bottom', 'container-border-bottom'],
    ['dropdown-container-border-left', 'container-border-left'],
    ['dropdown-container-border-radius', 'container-border-radius'],
    ['dropdown-container-box-shadow', 'container-box-shadow']
]

export const migrateMegaMenuContainerItemDesign = (
    menuStyleItem: StyleRef,
    megaMenuContainerItemStyleItem: StyleRef
) => {
    propertiesToMigrate.forEach(([from, to]) =>
        migratePropertyBetweenStyleItems({
            fromKey: from,
            toKey: to,
            from: menuStyleItem,
            to: megaMenuContainerItemStyleItem
        })
    )
}
